export const reviews: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Solar Technician | London',
    'I finally understand the complete picture of photovoltaic systems. This resource transformed how I approach solar projects professionally.',
  ],
  [
    'JW',
    'Jennifer W.',
    'Entry-Level PV Professional | Dublin',
    'I never felt confident discussing system sizing and performance with clients. Now I have the technical foundation to explain exactly how systems work.',
  ],
  [
    'NC',
    'Nora C.',
    'Electrician Transitioning to Solar | Amsterdam',
    'The calculation exercises and troubleshooting scenarios are exactly what I needed to strengthen my technical reasoning.',
  ],
];

export const moreResults: Array<[string, string, string, string]> = [
  [
    'RP',
    'Richard P.',
    'Solar Technician',
    'This resource finally explained why systems work. Now I have confident technical conversations with engineers and clients instead of following checklists.',
  ],
  [
    'JW',
    'Jennifer W.',
    'PV Professional',
    'The calculation exercises transformed how I approach sizing. I went from approximating to calculating precisely.',
  ],
  [
    'TM',
    'Thomas M.',
    'Solar Installation Manager',
    'The troubleshooting scenarios gave me systematic diagnostic reasoning. I solved three performance problems this quarter using these principles.',
  ],
];
